export const activeEvents = [
  'click',
  'dblclick',
  'focus',
  'hover',
  'keypress',
  'mousedown',
  'mouseenter',
  'mouseover',
  'scroll',
  'touchmove',
  'touchstart'
];

export const defaultRolloutPermille = 1000;

export const defaultActivityTimeoutMs = 600000;

export const defaultHeartbeatPulseIntervalMs = 20000;

export const defaultWorkerVersion = 1;

export const guacUrlSuffix = '/universal-app-configuration/v1/behaviors/page-heartbeat-v2/content';
